import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import Amplitude from "@Shared/utils/amplitude";
import Err from "@Broker/js/routes/error";
import { ADD_REFERRER_FOLLOW_UP } from "@Broker/@Modules/clients/referrers/store/referrer-actions";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { futureDate, requiredHTML } from "@Shared/@Utils/validation-rules";
import RichTextEditor from "@Shared/utils/rich-text-editor";
import { showToast } from "@Shared/utils/constants";
import TimeInput from "@Broker/@Modules/automation/automation/components/argument-types/time";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { mapActions, mapGetters } from "vuex";
import { REFERRER_CUSTOM_FIELDS_TAGS, REFERRER_CUSTOM_FIELDS_HINT_TAGS } from "@Broker/@Modules/clients/referrers/store/referrer-getters.ts";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerFollowUpTab",
  components: {
    DatepickerInput,
    TimeInput,
    MaterialInput,
    SimpleButton
  },
  mixins: [validationMixin],
  props: {
    tabData: {
      type: Object,
      default: () => ({})
    },
    referrerId: {
      type: [String, Number],
      required: true
    },
    currentTab: {
      type: String,
      required: true
    },
    formId: {
      type: String,
      default: "follow-up"
    }
  },
  data() {
    return _objectSpread(_objectSpread({
      description: "",
      scheduledDate: "",
      scheduledTime: this.followUpNotificationTime,
      assignees: []
    }, this.tabData), {}, {
      currentDate: moment().startOf("day"),
      loading: false,
      loadingSucceeded: false
    });
  },
  validations: {
    description: {
      required: requiredHTML
    },
    scheduledDate: {
      required,
      futureDate
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("ReferrerStore", [REFERRER_CUSTOM_FIELDS_TAGS, REFERRER_CUSTOM_FIELDS_HINT_TAGS])), mapFields("AccountStore", ["accountPreferences.followUpNotificationTime"])), {}, {
    followUpId() {
      return this.tabData.id;
    },
    canSave() {
      return !this.$v.$invalid;
    },
    customFieldsTags() {
      return this.REFERRER_CUSTOM_FIELDS_TAGS(this.referrerId);
    },
    customFieldsHintsTags() {
      return this.REFERRER_CUSTOM_FIELDS_HINT_TAGS(this.referrerId);
    }
  }),
  watch: {
    customFieldsTags: {
      deep: true,
      handler(value) {
        this.editor.updateOptions({
          mergeTags: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    },
    customFieldsHintsTags: {
      deep: true,
      handler(value) {
        this.editor.updateOptions({
          hints: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    },
    followUpNotificationTime(val) {
      this.scheduledTime = val;
    }
  },
  mounted() {
    this.scheduledTime = this.followUpNotificationTime;
    this.initTab();
    $(".note-codable").attr("id", "enter-description");
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [ADD_REFERRER_FOLLOW_UP])), {}, {
    initEditor() {
      const target = $(this.$refs.descriptionField);
      this.editor = new RichTextEditor(target, {
        placeholder: this.$t("global.actions.enterDescription"),
        airMode: true,
        height: "6vw",
        substitutionHints: true,
        showMergeTags: true,
        loadPreferences: false,
        visible: true,
        blockPastedImages: false,
        sanitizeContent: RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia,
        mergeTags: defaults => {
          return [...defaults, ...this.customFieldsTags];
        },
        hints: defaults => {
          return [...defaults, ...this.customFieldsHintsTags];
        },
        callbacks: {
          onChange: this.handleEditorChange
        }
      });
    },
    handleEditorChange(_, content) {
      this.description = content;
    },
    async handleSubmit() {
      this.loading = true;
      try {
        await this.ADD_REFERRER_FOLLOW_UP({
          id: this.referrerId,
          followUp: {
            description: this.editor.getHTML(),
            scheduledDate: this.scheduledDate,
            scheduledTime: this.scheduledTime,
            assignees: this.assignees
          }
        });
        this.loadingSucceeded = true;
        this.$emit("submit");
        this.resetFields();
        showToast("success", "activityAdded");
        Amplitude.updateCount("CLIENT_PROFILE_FOLLOWUPS_CREATED");
        this.$emit("add");
      } catch (e) {
        this.loadingSucceeded = false;
        Err.handle(e);
      } finally {
        this.loading = false;
      }
    },
    handleScheduledDateChange(value) {
      this.scheduledDate = value;
    },
    initTab() {
      this.initEditor();
    },
    async resetFields() {
      this.editor.setHTML("");
      this.description = "";
      this.scheduledDate = "";
      this.scheduledTime = this.followUpNotificationTime;
      await this.$nextTick();
      this.$v.$reset();
    }
  })
});